/* WunderKind front-end: header menus, mobile drawer, tabs, quick add. */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = function (cents) {
    var f = window.wkMoneyFormat || 'Rs. {{amount_no_decimals}}';
    var n = (cents / 100);
    var whole = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace('{{amount_no_decimals}}', whole).replace('{{amount}}', withDec);
  };

  /* Header dropdowns */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var triggers = [].slice.call(header.querySelectorAll('[data-dropdown]'));
    var hoverable = window.matchMedia('(hover:hover)').matches;
    var timer;

    function closeAll(keep) {
      triggers.forEach(function (btn) {
        if (btn.dataset.dropdown === keep) return;
        btn.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(btn.dataset.dropdown);
        if (panel) panel.classList.remove('is-open');
      });
    }

    function open(btn) {
      if (btn.getAttribute('aria-expanded') !== 'true') btn.dataset.openedAt = Date.now();
      closeAll(btn.dataset.dropdown);
      btn.setAttribute('aria-expanded', 'true');
      document.getElementById(btn.dataset.dropdown).classList.add('is-open');
    }

    triggers.forEach(function (btn) {
      var panel = document.getElementById(btn.dataset.dropdown);
      if (!panel) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen && Date.now() - (btn.dataset.openedAt || 0) > 450) closeAll();
        else open(btn);
      });

      if (hoverable) {
        var leave = function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (!panel.matches(':hover') && !btn.matches(':hover')) closeAll();
          }, 160);
        };
        btn.addEventListener('mouseenter', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { open(btn); }, 80);
        });
        btn.addEventListener('mouseleave', leave);
        panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
        panel.addEventListener('mouseleave', leave);
      }
    });

    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* Mobile menu */
  var drawer = document.getElementById('ck-menu-drawer');
  if (drawer) {
    var scrim = drawer.previousElementSibling;
    if (scrim) document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    var openers = [].slice.call(document.querySelectorAll('[data-menu-open]'));
    var lastFocus = null;

    function showMenu() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      root.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var close = drawer.querySelector('[data-menu-close]');
      if (close) setTimeout(function () { close.focus(); }, 60);
    }
    function hideMenu() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      root.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', showMenu); });
    [].slice.call(drawer.querySelectorAll('[data-menu-close]')).forEach(function (b) {
      b.addEventListener('click', hideMenu);
    });
    if (scrim) scrim.addEventListener('click', hideMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) hideMenu();
    });
  }

  /* Product tabs */
  [].slice.call(document.querySelectorAll('[data-tabset]')).forEach(function (set) {
    var tabs = [].slice.call(set.querySelectorAll('[data-tab]'));
    var panels = [].slice.call(set.querySelectorAll('[data-panel]'));

    function select(key) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.tab === key)); });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== key; });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t.dataset.tab); });
    });

    set.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      next.focus();
      next.click();
    });
  });

  /* Cart drawer: opens by itself whenever something is added to the cart
     (any add-to-cart on the site goes through cart/add.js), and from the
     header cart icon. Closes on the X, the dimmed side, or Escape. */
  var cd = document.querySelector('[data-cart-drawer]');
  if (cd) {
    root.classList.add('wk-has-cd');
    var cdScrim = document.querySelector('.wk-cd-scrim');
    /* The header section is its own stacking layer, so sections after it (the
       promo strip) would paint over the drawer. Lift both to the body. */
    if (cdScrim) document.body.appendChild(cdScrim);
    /* The closed drawer waits off the right edge of the screen. Inside a
       full-screen clipping layer it can never widen the page, which made
       phones slide sideways. */
    var cdWrap = document.createElement('div');
    cdWrap.className = 'wk-cd-wrap';
    document.body.appendChild(cdWrap);
    cdWrap.appendChild(cd);
    var cdItems = cd.querySelector('[data-cd-items]');
    var cdFoot = cd.querySelector('[data-cd-foot]');
    var cdFree = cd.querySelector('[data-cd-free]');
    var cdTotal = cd.querySelector('[data-cd-total]');
    var cdCount = cd.querySelector('[data-cd-count]');
    var cdEmpty = cd.querySelector('[data-cd-empty]');
    var freeAt = parseInt(cd.dataset.free, 10) || 0;
    var cdLast = null;
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
    var img = function (u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=180' : ''; };
    var trash = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 7h15M9.5 7V5.2c0-.7.5-1.2 1.2-1.2h2.6c.7 0 1.2.5 1.2 1.2V7M6.5 7l.8 11.6c.1 1 .9 1.9 2 1.9h5.4c1 0 1.9-.8 2-1.9L17.5 7M10.2 11v5.5M13.8 11v5.5"/></svg>';

    /* Gift wrap / gift note: one per order. Extra quantity or a second line is trimmed. */
    var isGift = function (it) { return it.product_type === 'Gift add-on' || /^(gift-wrap|gift-card-note)$/.test(it.handle); };
    var giftFix = function (cart) {
      var seen = {};
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (!isGift(it)) continue;
        if (seen[it.variant_id]) return { line: i + 1, quantity: 0 };
        seen[it.variant_id] = true;
        if (it.quantity > 1) return { line: i + 1, quantity: 1 };
      }
      return null;
    };
    var renderCart = function (cart) {
      var fix = cart.items && giftFix(cart);
      if (fix) { change(fix.line, fix.quantity); return; }
      refreshCount(cart.item_count);
      if (cdCount) cdCount.textContent = cart.item_count;
      if (!cart.item_count) {
        cdItems.innerHTML = cdEmpty ? cdEmpty.innerHTML : '';
        cdFoot.hidden = true;
        cdFree.hidden = true;
        return;
      }
      cdItems.innerHTML = '<ul class="wk-cd__list">' + cart.items.map(function (it, i) {
        var variant = it.product_has_only_default_variant ? '' : (it.variant_title || '');
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<li class="wk-cd__item" data-line="' + (i + 1) + '">' +
          '<a class="wk-cd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
          '<div class="wk-cd__info">' +
            '<a class="wk-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (variant ? '<span class="wk-cd__var">' + esc(variant) + '</span>' : '') +
            '<div class="wk-cd__line">' +
              (isGift(it)
                ? '<span class="wk-cd__var">' + (it.properties && it.properties.Message ? '&ldquo;' + esc(it.properties.Message) + '&rdquo;' : 'One per order') + '</span>'
                : '<div class="wk-cd__qty">' +
                  '<button type="button" data-cd-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                  '<span aria-live="polite">' + it.quantity + '</span>' +
                  '<button type="button" data-cd-qty="1" aria-label="Increase quantity">+</button>' +
                '</div>') +
              '<span class="wk-cd__price">' + was + money(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="wk-cd__rm" type="button" data-cd-remove aria-label="Remove ' + esc(it.product_title) + '">' + trash + '</button>' +
        '</li>';
      }).join('') + '</ul>';
      cdTotal.textContent = money(cart.total_price);
      cdFoot.hidden = false;
      if (freeAt > 0) {
        var left = freeAt - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price / freeAt * 100));
        cdFree.innerHTML = '<p>' + (left > 0
          ? 'Add <strong>' + money(left) + '</strong> more for <strong>free delivery</strong>'
          : '<svg class="wk-i"><use href="#ck-truck"/></svg> You get <strong>free delivery</strong>') + '</p>' +
          '<span class="wk-cd__bar"><i style="width:' + pct + '%"></i></span>';
        cdFree.classList.toggle('is-done', left <= 0);
        cdFree.hidden = false;
      }
    };

    var loadCart = function () {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(renderCart);
    };

    var openCart = function () {
      if (cd.classList.contains('is-open')) return;
      cdLast = document.activeElement;
      cd.classList.add('is-open');
      cdWrap.classList.add('is-open');
      if (cdScrim) cdScrim.classList.add('is-open');
      cd.setAttribute('aria-hidden', 'false');
      root.style.overflow = 'hidden';
      setTimeout(function () { var x = cd.querySelector('.wk-cd__close'); if (x) x.focus({ preventScroll: true }); }, 80);
    };
    var closeCart = function () {
      cd.classList.remove('is-open');
      cdWrap.classList.remove('is-open');
      if (cdScrim) cdScrim.classList.remove('is-open');
      cd.setAttribute('aria-hidden', 'true');
      root.style.overflow = '';
      if (cdLast && document.contains(cdLast)) cdLast.focus({ preventScroll: true });
    };
    /* Celebration: when something is added, a burst of brand-coloured sparkles
       rises from the Checkout button for about 3 seconds. Turn off in the
       header section ("Sparkles when added"). */
    var celebrate = function () {
      if (cd.dataset.fx !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var btn = cd.querySelector('.wk-cd__foot:not([hidden]) .wk-cd__checkout');
      if (!btn || !btn.animate) return;
      var old = cd.querySelector('.wk-cd__fx');
      if (old) old.remove();
      var layer = document.createElement('div');
      layer.className = 'wk-cd__fx';
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:5';
      cd.appendChild(layer);
      var box = cd.getBoundingClientRect(), b = btn.getBoundingClientRect();
      var cx = b.left - box.left + b.width / 2, cy = b.top - box.top + b.height / 2;
      var colours = ['#F6B740', '#F476AD', '#72C9E9', '#56339A', '#4CD38A', '#FF7A45', '#FF4D6D', '#B79BEA'];
      var star = '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 0l2.6 8.4L24 12l-9.4 3.6L12 24l-2.6-8.4L0 12l9.4-3.6z"/></svg>';
      /* Party popper: pieces shoot up and out from Checkout, then drift down and fade. */
      for (var i = 0; i < 90; i++) {
        var el = document.createElement('i');
        var kind = i % 4, size = kind === 0 ? 13 + Math.random() * 8 : 8 + Math.random() * 6;
        var c = colours[i % colours.length];
        el.style.cssText = 'position:absolute;left:' + (cx + (Math.random() - .5) * 40) + 'px;top:' + (cy - 10) + 'px;width:' + size + 'px;height:' + (kind >= 2 ? size * .45 : size) + 'px;margin:-' + size / 2 + 'px;color:' + c + ';opacity:0;' +
          (kind === 0 ? '' : 'background:' + c + ';border-radius:' + (kind === 1 ? '50%' : '2px') + ';');
        if (kind === 0) el.innerHTML = star;
        layer.appendChild(el);
        var ang = (-90 + (Math.random() - .5) * 110) * Math.PI / 180;
        var pow = 180 + Math.random() * Math.max(200, cy - 160);
        var px = Math.cos(ang) * pow, py = Math.sin(ang) * pow;
        var fall = 90 + Math.random() * 120, spin = (Math.random() - .5) * 900;
        el.animate([
          { transform: 'translate(0,0) scale(.3) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + px + 'px,' + py + 'px) scale(1) rotate(' + spin * .5 + 'deg)', opacity: 1, offset: .22, easing: 'cubic-bezier(.3,.6,.5,1)' },
          { transform: 'translate(' + px * 1.1 + 'px,' + (py + fall * .7) + 'px) scale(.95) rotate(' + spin * .85 + 'deg)', opacity: 1, offset: .78 },
          { transform: 'translate(' + px * 1.15 + 'px,' + (py + fall) + 'px) scale(.9) rotate(' + spin + 'deg)', opacity: 0 }
        ], { duration: 3000 + Math.random() * 900, delay: Math.random() * 200, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'both' });
      }
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }], { duration: 600, delay: 150, easing: 'ease-out' });
      setTimeout(function () { layer.remove(); }, 4400);
    };
    window.wkCart = { open: function () { loadCart(); openCart(); }, close: closeCart, refresh: loadCart };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { closeCart(); return; }
      var link = e.target.closest('[data-cart-link]');
      if (link && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); window.wkCart.open(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cd.classList.contains('is-open')) closeCart();
    });
    /* A tap anywhere outside the open drawer closes it. */
    cdWrap.addEventListener('click', function (e) { if (e.target === cdWrap) closeCart(); });
    document.addEventListener('click', function (e) {
      if (!cd.classList.contains('is-open') || !document.contains(e.target) || cd.contains(e.target)) return;
      if (e.target.closest('[data-cart-link]')) return;
      closeCart();
    });

    var change = function (line, qty) {
      cd.classList.add('is-busy');
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { cd.classList.remove('is-busy'); if (cart && cart.items) renderCart(cart); else loadCart(); })
        .catch(function () { cd.classList.remove('is-busy'); loadCart(); });
    };
    cdItems.addEventListener('click', function (e) {
      var li = e.target.closest('[data-line]');
      if (!li) return;
      var line = parseInt(li.dataset.line, 10);
      var q = e.target.closest('[data-cd-qty]');
      if (q) {
        var now = parseInt(li.querySelector('.wk-cd__qty span').textContent, 10) || 1;
        change(line, Math.max(0, now + parseInt(q.dataset.cdQty, 10)));
      } else if (e.target.closest('[data-cd-remove]')) {
        li.classList.add('is-out');
        change(line, 0);
      }
    });

    /* /cart page: trim extra gift quantity and hide its stepper. */
    if (/\/cart\/?$/.test(location.pathname)) {
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var fix = giftFix(cart);
          if (fix) {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(fix)
            }).then(function () { location.reload(); });
          }
          cart.items.forEach(function (it, i) {
            if (!isGift(it)) return;
            var row = document.getElementById('CartItem-' + (i + 1));
            var q = row && row.querySelector('quantity-input, .quantity');
            if (q) q.style.visibility = 'hidden';
          });
        }).catch(function () {});
    }

    /* Every add to cart, from any section, opens the drawer. */
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (r.ok) { loadCart().then(function () { openCart(); setTimeout(celebrate, 350); }); }
        }).catch(function () {});
      }
      return p;
    };
  }

  /* Quick add */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wk wk-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toast.timer);
    toast.timer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }

  function refreshCount(count) {
    [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    var btn = document.querySelector('[data-cart-link]');
    if (btn) btn.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (!res.ok) {
          showToast('<svg class="wk-i"><use href="#ck-close"/></svg><span>' + (res.data.description || 'That one could not be added.') + '</span>');
          return;
        }
        var added = res.data.items ? res.data.items[0] : res.data;
        showToast(
          '<svg class="wk-i"><use href="#ck-check"/></svg><span>' +
          (added.product_title || 'Added') + ' &mdash; ' + money(added.final_line_price || added.final_price || 0) +
          '<br><a href="' + window.Shopify.routes.root + 'cart">View cart</a></span>'
        );
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { refreshCount(cart.item_count); });
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        showToast('<svg class="wk-i"><use href="#ck-close"/></svg><span>Something went wrong. Try again.</span>');
      });
  });
  /* Live search: as soon as a word is typed in the header search, matching
     toys drop down under the box (Shopify predictive search). Arrow keys
     move through them, Enter opens one, Escape closes. */
  [].slice.call(document.querySelectorAll('form.wk-search')).forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || !window.fetch) return;
    var limit = parseInt(form.dataset.psLimit, 10) || 6;
    var box = document.createElement('div');
    box.className = 'wk-ps';
    box.id = 'wk-ps-' + Math.random().toString(36).slice(2, 8);
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    form.appendChild(box);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
    var rs = function (v) { return money(Math.round(parseFloat(v) * 100)); };
    var timer, ctrl, last = '', active = -1;

    function links() { return [].slice.call(box.querySelectorAll('a')); }
    function show(on) { box.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false'); form.classList.toggle('is-ps-open', on); }
    function mark(i) {
      var ls = links();
      active = ls.length ? (i + ls.length) % ls.length : -1;
      ls.forEach(function (a, k) { a.classList.toggle('is-on', k === active); a.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      if (active > -1) ls[active].scrollIntoView({ block: 'nearest' });
    }
    function allUrl(q) { return form.action + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
    function render(q, products) {
      var html = '';
      if (products.length) {
        html += '<p class="wk-ps__label">Toys</p><ul class="wk-ps__list">' + products.map(function (p) {
          var was = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + rs(p.compare_at_price_max) + '</s>' : '';
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return '<li><a class="wk-ps__item" href="' + esc(p.url) + '" role="option">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="wk-ps__ph"></span>') +
            '<span class="wk-ps__txt"><span class="wk-ps__title">' + esc(p.title) + '</span>' +
            '<span class="wk-ps__price"><b>' + rs(p.price) + '</b>' + was + '</span></span></a></li>';
        }).join('') + '</ul>';
      } else {
        html += '<p class="wk-ps__none">No toys found for &ldquo;' + esc(q) + '&rdquo;. Try a simpler word.</p>';
      }
      html += '<a class="wk-ps__all" href="' + esc(allUrl(q)) + '" role="option">See all results for &ldquo;' + esc(q) + '&rdquo;<svg class="wk-i" aria-hidden="true"><use href="#ck-right"/></svg></a>';
      box.innerHTML = html;
      active = -1;
      show(true);
    }
    function lookup() {
      var q = input.value.trim();
      if (q.length < 2) { last = ''; show(false); return; }
      if (q === last) { show(true); return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      form.classList.add('is-ps-busy');
      var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + limit + '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          form.classList.remove('is-ps-busy');
          if (input.value.trim() !== q) return;
          render(q, (d.resources && d.resources.results && d.resources.results.products) || []);
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') form.classList.remove('is-ps-busy'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(lookup, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && box.innerHTML) show(true); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); links()[active].click(); }
      else if (e.key === 'Escape') { show(false); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) show(false); });
  });
})();
